export default {
  introSteps: {
    exportFile: 'Экспортируйте опрос без данных с другого сервера Arena (например, Dev или QA)',
    selectFile: 'Выберите экспортированный файл (.zip): он сравнивается с этим опросом, и отображаются различия',
    applyChanges:
      'Проверьте различия и примените выбранные изменения к этому опросу (удаления никогда не выбираются по умолчанию)',
    publish: 'Изменения сохраняются как черновик: проверьте форму и опубликуйте опрос, чтобы они вступили в силу',
  },
  fileTooLarge:
    'Выбранный файл слишком большой (макс. {{maxSize}} МБ): экспортируйте опрос без данных, записи и их файлы не нужны для сравнения опросов',
  selectNewSource: 'Выбрать новый источник',
  selectNewSourceInfo: 'Отменить это сравнение и выбрать другой файл опроса или опрос',
  refreshComparison: 'Обновить сравнение',
  refreshComparisonInfo: 'Снова сравнить тот же файл с текущей версией этого опроса (например, после его изменения)',
  sourceSurvey: 'Сравниваемый опрос: {{name}}',
  compareWithSurvey: 'Или сравните с другим опросом на этом сервере:',
  fingerprint: {
    thisSurvey: 'Этот опрос',
    comparedSurvey: 'Сравниваемый опрос',
    equal: 'Совпадает с этим опросом',
    different: 'Отличается от этого опроса',
    label: 'Отпечаток',
    structural: 'структурный',
    info: 'Отпечатки определения опроса (черновик). Одинаковые отпечатки означают одинаковые определения. Первый включает внутренние идентификаторы: он совпадает только для копий одного и того же опроса (например, экспортированного и импортированного на другой сервер). Структурный использует имена и коды: он совпадает и для опросов, созданных отдельно с той же структурой. Имена, метки, идентификаторы, даты и статус публикации в него не входят.',
    copy: 'Скопировать полный отпечаток: {{value}}',
    copied: 'Отпечаток скопирован в буфер обмена',
  },
  identical: 'Опросы идентичны',
  counts: '{{added}} только в сравниваемом опросе, {{changed}} изменено, {{removed}} только в этом опросе',
  surveyInfoChanged: 'Информация об опросе (языки, циклы, метки) различается: см. вкладку «Информация об опросе»',
  onlyDifferences: 'Показывать только различия',
  hideLayoutOnly: 'Скрыть различия только в макете',
  apply: 'Применить выбранные изменения ({{count}})',
  applyConfirm: `Применить {{count}} выбранных изменений к этому опросу?
Изменения сохраняются как черновик: они затронут записи только после публикации опроса.`,
  willBeDeleted: 'будет удалено',
  removedNodeDefInfo:
    'Это определение узла есть только в этом опросе: применение этого изменения удалит его (вместе с потомками) из этого опроса.',
  removedItemInfo: 'Только в этом опросе: применение этого изменения удалит его из этого опроса.',
  applyConfirmWithDeletionsHeader: 'Подтвердите удаление',
  applyConfirmWithDeletions:
    'Применить {{count}} выбранных изменений к этому опросу?\n\n**{{deletionsCount}} из них удаляют элементы этого опроса** (элементы, которых нет в сравниваемом опросе):\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: 'Применить и удалить',
  confirmSurveyName: 'Введите название этого опроса для подтверждения:',
  deletionOfItemsOf: 'элементы только в этом опросе из **{{name}}**',
  moreDeletions: '... и ещё {{count}}',
  applyCompleted:
    'Применено изменений: {{applied}}, пропущено: {{skipped}}. Опубликуйте опрос, чтобы они вступили в силу.',
  tabs: {
    nodeDefs: 'Определения узлов',
    categories: 'Категории',
    taxonomies: 'Таксономии',
    surveyInfo: 'Информация об опросе',
    surveyFiles: 'Файлы',
  },
  status: {
    added: 'Только в сравниваемом опросе',
    changed: 'Изменено',
    removed: 'Только в этом опросе',
  },
  statusLabel: 'Статус',
  matchedBy: {
    uuid: 'Сопоставлено по внутреннему идентификатору',
    name: 'Сопоставлено по имени (внутренние идентификаторы различаются)',
    manual: 'Сопоставлено вручную: применяется как переименование',
  },
  renameCandidate: 'Возможно, это переименованный «{{name}}» из этого опроса',
  possibleRename: 'возможное переименование',
  matchAsRename: 'Сопоставить как переименованный',
  unmatch: 'Отменить сопоставление',
  props: {
    branding: 'Брендинг',
    columnsNo: 'Столбцы',
    columnsOrder: 'Порядок столбцов',
    cycles: 'Циклы',
    defaultCycleKey: 'Цикл по умолчанию',
    descriptions: 'Описания',
    extra: 'Дополнительные свойства',
    family: 'Семейство',
    fieldManualLinks: 'Ссылки на полевое руководство',
    formLayout: 'Макет формы',
    genus: 'Род',
    gridPosition: 'строка {{row}}, столбец {{column}}, ширина {{width}}, высота {{height}}',
    itemExtraDef: 'Дополнительные свойства',
    keepNonApplicableValues: 'Сохранять неактуальные значения',
    labels: 'Метки',
    languages: 'Языки',
    layout: 'Макет',
    levels: 'Уровни',
    messages: 'Сообщения',
    pagesOrder: 'Порядок страниц',
    parent: 'Родительская сущность',
    preloadedMapLayersEnabled: 'Предзагруженные слои карты включены',
    reportingData: 'Отчетные данные',
    sampleBasedImageInterpretationEnabled: 'Интерпретация изображений на основе образцов',
    samplingPolygon: 'Полигон выборки',
    scientificName: 'Научное название',
    size: 'Размер',
    srs: 'Системы пространственной привязки',
    surveyDocOptions: 'Параметры документации опроса',
    userExtraPropDefs: 'Дополнительные свойства пользователей',
    validations: 'Проверки',
    vernacularLanguageCodes: 'Языки народных названий',
    vernacularNames: 'Народные названия',
  },
  fileTypes: {
    preloadedMapLayer: 'Предзагруженный слой карты',
    surveyDocImage: 'Изображение документации опроса',
    brandingSurveyLogo1: 'Логотип опроса 1',
    brandingSurveyLogo2: 'Логотип опроса 2',
    brandingSurveyLogo3: 'Логотип опроса 3',
    brandingLandingBackground: 'Фон стартовой страницы',
  },
  cycle: 'цикл {{cycle}}',
  property: 'Свойство',
  sourceValue: 'Сравниваемый опрос',
  targetValue: 'Этот опрос',
  emptyValue: '(пусто)',
  layoutOnly: 'только макет',
  selectItem: 'Выберите элемент, чтобы увидеть подробности',
  noDifferences: 'Различий нет',
  identicalItem: 'Различий нет',
  dependsOn: 'Применяется вместе с:',
  itemsCount: 'элементы: {{added}} добавлено, {{changed}} изменено, {{removed}} только в этом опросе',
  itemCode: 'Код',
  taxaCount: 'таксоны: {{added}} добавлено, {{changed}} изменено, {{removed}} только в этом опросе',
  taxonCode: 'Код',
  changes: 'Изменения',
  moreItems: '... и ещё {{count}} элементов',
  categoryRemoval: 'Удалить элементы (и уровни), которые есть только в этом опросе',
  taxonomyRemoval: 'Удалить таксоны и народные названия, которые есть только в этом опросе',
  removalSelected: 'удаление выбрано',
  publishedKept: '(опубликованные: сохраняются)',
  reasons: {
    categoryInUse: 'Категория используется определениями узлов, которые не удаляются',
    categoryMissing: 'Категория отсутствует в этом опросе',
    cycleMissing: 'В этом опросе отсутствует цикл',
    dependencyNotApplicable: 'Изменение, от которого оно зависит, не может быть применено',
    parentMissing: 'Родительское определение узла отсутствует в этом опросе',
    publishedCategoryChanged: 'Категорию опубликованного определения узла изменить нельзя',
    publishedKeyChanged: 'Свойство «ключ» опубликованного определения узла изменить нельзя',
    publishedMoveNotSupported: 'Опубликованное определение узла нельзя переместить в другую сущность',
    publishedMultipleChanged: 'Свойство «множественное» опубликованного определения узла изменить нельзя',
    publishedTaxonomyChanged: 'Таксономию опубликованного определения узла изменить нельзя',
    publishedTypeChanged: 'Тип опубликованного определения узла изменить нельзя',
    taxonomyInUse: 'Таксономия используется определениями узлов, которые не удаляются',
    taxonomyMissing: 'Таксономия отсутствует в этом опросе',
    nodeDefUsedByOthers: 'Другие определения узлов используют его в своих выражениях: обновите и их',
    publishedCategoryItemsKept: 'Опубликованные элементы нельзя удалить: они сохраняются',
    publishedCategoryLevelsKept: 'Опубликованные уровни нельзя удалить: они сохраняются',
    publishedCyclesRemoved: 'Удаление циклов из опубликованного определения узла удаляет его данные в этих циклах',
    publishedLanguagesRemoved: 'Удаление языков удаляет их метки при публикации опроса',
    publishedNameChanged:
      'Переименование опубликованного определения узла: выражения, использующие старое имя, нужно обновить',
    publishedNodeDefDeleted: 'Определение узла опубликовано: его данные будут удалены при публикации опроса',
    publishedSurveyCyclesRemoved: 'Удаление циклов удаляет их записи при публикации опроса',
    publishedTaxaKept: 'Опубликованные таксоны нельзя удалить: они сохраняются',
    publishedVernacularNamesKept: 'Опубликованные народные названия нельзя удалить: они сохраняются',
  },
}
